import {SavedAdvancedFilter, SelectedAdvancedFilter} from '@bmc-ux/adapt-angular';

export enum COLUMN_HEADER {
  DB_NOTES = 'DB NOTES',
  VENDOR = 'VENDOR',
  FAMILY = 'FAMILY',
  TYPE = 'TYPE',
  ARCHITECTURE = 'ARCHITECTURE',
  ARCH = 'ARCH',
  NAME = 'NAME',
  VERSION = 'VERSION',
  ACTIONS = 'ACTIONS',
  BUILD = 'BUILD',
  HW_NAME = 'HW NAME',
  HW_ARCH = 'HW ARCH',
  OS_NOTES = 'OS NOTES',
  OS_DETAILS = 'OS DETAILS',
  SP_FP_PATCH = 'SP/FP/PATCH',
  SMART_NUMBER = 'SMART NUMBER',
  EDITOR = 'EDITOR',
  PRODUCT_TYPE = 'PRODUCT TYPE',
  PRODUCT_STATUS = 'PRODUCT STATUS',
  SUPPORT_STATUS = 'SUPPORT STATUS',
  PUBLISHING_STATUS = 'PUBLISHING STATUS',
  PUBLISHED_DATA = 'PUBLISHED DATA',
  PUBL = 'PUBL',
  TABS = 'TABS',
  TABS_HEADER_TOOLTIP = 'NUMBER OF PRODUCT-FILLED TABS',
  POSITIVE_FEEDBACK = 'POSITIVE FEEDBACK',
  NEGATIVE_FEEDBACK = 'NEGATIVE FEEDBACK',
  VIEWS = 'VIEWS',
  VIEWS_EMPTY = 'VIEWS EMPTY',
  VIEWS_HEADER_TOOLTIP = 'NUMBER OF PRODUCT VIEWS ON CMX CLIENT',
  VIEWS_EMPTY_HEADER_TOOLTIP = 'NUMBER OF EMPTY PRODUCT VIEWS ON CMX CLIENT',
  SUB_TYPE = 'SUB TYPE',
  BUSINESS_UNIT = 'BU',
  PRODUCT_LINE = 'PRODUCT LINE',
  PRODUCT_FAMILY = 'PRODUCT FAMILY',
  DATE = 'DATE',
  RELEASE_DATE = 'RELEASE DATE',
  FULL_SUPP_END_DATE = 'FULL SUPPORT END DATE',
  END_OF_VERSION_SUPPORT = 'END OF VERSION SUPPORT',
  USER = 'USER',
  ACTIVITY = 'ACTIVITY',
  PARENT_NAME = 'PARENT NAME'
}

export enum TABLE_SELECTION_MODE {
  MULTIPLE = 'multiple',
  SINGLE = 'single'
}

export class TableFilterUrlParams {
  constructor(
    public filterText: string,
    public publishingStatus: string,
    public hasPublishedVersion: boolean = null,
    public productStatus: string,
    public productSubType: string,
    public productFillInTabsCount: string,
    public baseBusinessUnit: string,
    public baseProductLine: string,
    public baseProductFamily: string,
    public availabityDate: string,
    public pastDays: string
  ) {
    this.filterText = filterText;
    this.publishingStatus = publishingStatus;
    this.hasPublishedVersion = hasPublishedVersion;
    this.productStatus = productStatus;
    this.productSubType = productSubType;
    this.productFillInTabsCount = productFillInTabsCount;
    this.baseBusinessUnit = baseBusinessUnit;
    this.baseProductLine = baseProductLine;
    this.baseProductFamily = baseProductFamily;
    this.availabityDate = availabityDate;
    this.pastDays = pastDays;
  }
}

export enum TABLE_DATE_TYPE {
  DATE = 'DATE',
  DATE_TIME = 'DATE_TIME'
}

export class TableDate {
  constructor(
    public year: number,
    public month: number,
    public date: number,
  ) {
    this.year = year;
    this.month = month;
    this.date = date;
  }
}

export class TableDateTime implements TableDate {
  constructor(
    public year: number,
    public month: number,
    public date: number,
    public hours: number,
    public minutes: number,
    public seconds: number
  ) {
    this.year = year;
    this.month = month;
    this.date = date;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
  }
}

export class SavedAdvancedFilterEvent {
  constructor(
    public activeSavedFilter: TableSavedAdvancedFilter,
    public savedFilters: TableSavedAdvancedFilter[]
  ) {
    this.activeSavedFilter = activeSavedFilter;
    this.savedFilters = savedFilters;
  }
}

export class TableSavedAdvancedFilter implements SavedAdvancedFilter {
  filters: SelectedAdvancedFilter[];
  id: string;
  name: string;
  isCreatedByOtherUsers?: boolean;
  pastDays?: number;
}
